import { Flex } from '@chakra-ui/react'
import { Header } from 'src/screens/Company-settings/Charge/components/Header'
import { TableIndex } from './components/Table'
import { FooterIndex } from './components/Footer'
import { useSession } from 'src/contexts'
import { useEffect, useState } from 'react'
import { getCharges } from 'src/services/api'

interface IBoletos {
  cnpjCpf: string
  email: string
  dtVencimento: string
  valor: string
  dtPagamento: string
  boleto: string
  nota: string
}

export const Charge = () => {
  const { session } = useSession()

  const [listInfoBoleto, setListInfoBoleto] = useState<IBoletos[]>([])

  useEffect(() => {
    const loadCharges = async () => {
      try {
        const data = await getCharges(session.company.document)
        const list: IBoletos[] = Array.isArray(data) ? (data as IBoletos[]) : []
        setListInfoBoleto(list)
      } catch (error) {
        console.error(error)
        setListInfoBoleto([])
      }
    }
    loadCharges()
  }, [session.company.document])

  return (
    <Flex flexDir={'column'} mt="10px" ml="17px">
      <Flex>
        <Header />
      </Flex>
      <Flex>
        <TableIndex listInfoBoleto={listInfoBoleto} />
      </Flex>
      <Flex>
        <FooterIndex />
      </Flex>
    </Flex>
  )
}
